// Republic Atlas - Auth Provider
// Initializes Firebase Auth listener on app mount

import { useEffect, ReactNode } from 'react';
import { useAuthStore } from '@/store/authStore';

interface AuthProviderProps {
  children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  const initialize = useAuthStore((state) => state.initialize);
  const isInitialized = useAuthStore((state) => state.isInitialized);

  useEffect(() => {
    // Initialize Firebase Auth listener - this restores session on page load/refresh
    const unsubscribe = initialize();
    
    return () => {
      // Cleanup listener on unmount
      unsubscribe();
    };
  }, [initialize]);

  // Show nothing until auth is initialized to prevent flash
  if (!isInitialized) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-900">
        <div className="animate-pulse text-white text-lg">Loading...</div>
      </div>
    );
  }

  return <>{children}</>;
}

